import React from 'react';
import { Button, Input, Checkbox } from 'antd';
import { useFormDataContext } from '../../../contexts/form-data.ctx';
import Text from 'antd/lib/typography/Text';
import { Box } from '../../../../../components/Box';
import { Option, Select } from '../../../../../components/Input';
import { countries } from '../../../../editor/countries/countries';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import AddressAutoCompleteInput from '../AddressAutocompleteInput';
import AddressAutoCompleteSeperatedInput from '../AddressAutocompleteSeperatedInput';
import { translations } from '../../../../../utils/LocalizedStrings';

function PresentProkurista({
  person,
  prokura,
  index,
  changePersonProkurista,
  removePerson
}) {

  return (
    <>
      {person && (
        <>
          <span className="gridRow choose-person-container">
            <Box className='gridItem'>
              <Select
                id={"presence_person_" + index}
                label={translations.artifacts.PresenceProkurista.chooseProxy}
                placeholder={translations.artifacts.PresenceProkurista.proxy}
                onChange={(value) => changePersonProkurista(value, index)}
                value={person.index}>
                {prokura?.map((prokurista, index) => (
                  <Option value={index}>{prokurista.personName.formatedName}</Option>
                ))}
              </Select>
            </Box>
            <Button
              onClick={() => removePerson(index)}
              type="primary"
              className='removeButton'>
              <MinusOutlined />
            </Button>
          </span>
        </>
      )}
    </>
  );
}

export default PresentProkurista;
